import { render, staticRenderFns } from "./PurpleChip2.vue?vue&type=template&id=34e130a3&scoped=true"
import script from "./PurpleChip2.vue?vue&type=script&lang=ts"
export * from "./PurpleChip2.vue?vue&type=script&lang=ts"
import style0 from "./PurpleChip2.vue?vue&type=style&index=0&id=34e130a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e130a3",
  null
  
)

export default component.exports